/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";

// Images
import bgSippenSause from "assets/images/Logo/SippenSause/Logo.png";
import bgAstravelis from "assets/images/Logo/Astravelis/Logo.png";
import bgTitansreign from "assets/images/Logo/TitansReign/Logo.png";
import bgSPWOnline from "assets/images/Logo/SPWOnline/Logo.png";

function GamePresentation() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <MKTypography variant="h2" color="black" textAlign="center" mb={6}>
          Published Games
        </MKTypography>
        <MKTypography variant="body1" color="black" textAlign="center" mb={6}>
          In the following section you can find all the games I have published so far. If you want
          to know more about the games, just click on the card and you will be redirected to the
          game page.
        </MKTypography>
        <Grid container item xs={11} spacing={3} mb={10} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={5} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgSippenSause}
                icon="touch_app"
                title={<>SippenSause</>}
                description="The drinkingapp you need for a good party!"
              />
              <RotatingCardBack
                image={bgSippenSause}
                title="Discover More"
                description="Check out my own drinking game app SippenSause. It supports both germany and english language"
                action={{
                  type: "internal",
                  route: "/pages/landing-pages/sippensause",
                  label: "Goto SippenSause",
                }}
              />
            </RotatingCard>
          </Grid>
        </Grid>
        <MKTypography variant="h2" color="black" textAlign="center" mb={4}>
          Upcoming Games
        </MKTypography>
        <MKTypography variant="body1" color="black" textAlign="center" mb={4}>
          Here you can find all the games I am currently working on or are planed for the future. If
          you want to know more about the games, just click on the card and you will be redirected
          to the game page.
        </MKTypography>
        <Grid container item xs={11} spacing={3} mb={10} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={5} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgAstravelis}
                icon="touch_app"
                title={<>Astravelis</>}
                description="Have you ever wanted to be an adventurer?"
              />
              <RotatingCardBack
                image={bgAstravelis}
                title="Discover More"
                description="Check out my own drinking game app SippenSause. It supports both germany and english language"
                action={{
                  type: "internal",
                  route: "/pages/landing-pages/astravelis",
                  label: "Goto Astravelis",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={5} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgSPWOnline}
                icon="touch_app"
                title={<>Space Pilets War Online</>}
                description="A space shooter game where you can play with your friends online!"
              />
              <RotatingCardBack
                image={bgSPWOnline}
                title="Discover More"
                description="Check out my own drinking game app SippenSause. It supports both germany and english language"
                action={{
                  type: "internal",
                  route: "/pages/landing-pages/astravelis",
                  label: "Goto Astravelis",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={5} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgTitansreign}
                icon="touch_app"
                title={<>Titans Reign</>}
                description="A traiding card game where you can collect cards and build your own deck!"
              />
              <RotatingCardBack
                image={bgTitansreign}
                title="Discover More"
                description="Check out my own drinking game app SippenSause. It supports both germany and english language"
                action={{
                  type: "internal",
                  route: "/pages/landing-pages/sippensause",
                  label: "Goto SippenSause",
                }}
              />
            </RotatingCard>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default GamePresentation;
